import React from 'react';
import PropTypes from 'prop-types';
import getSrc from '../../utils/getSrc';

const Img = (props) => {
  const imgProps = Object.assign({}, props);
  if (!props.src) {
    return null;
  }
  delete imgProps.src;
  delete imgProps.styleName;
  return <img src={getSrc(props.src, props.styleName, props.derivatives)} {...imgProps} />;
};

Img.propTypes = {
  src: PropTypes.oneOfType([PropTypes.shape({
    url: PropTypes.string,
    meta: PropTypes.shape({
      derivatives: PropTypes.objectOf(PropTypes.string),
    }),
  }), PropTypes.string]),
  styleName: PropTypes.string,
  derivatives: PropTypes.objectOf(PropTypes.string),
};

Img.defaultProps = {
  src: null,
  styleName: 'original',
  derivatives: null,
};

export default Img;
